<template>
  <div style="width:100%;">
    <!-- <CCol col="12" xl="12"> -->
    <!-- <CCard>
      <CCardHeader>Daily Information</CCardHeader>
      <CCardBody v-if="data"> -->
      <div style="width:100%;float:left;" v-if="data && dashShow && budgets">
        <CCard v-for="(value, key) in data">
          <CCardHeader style="background-color: #81b440;">{{key}}</CCardHeader>
          <CCardBody style="overflow-y:scroll;">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th v-for="val in fields">{{val.toUpperCase()}}</th>
                  <th>Totals</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="val in value">
                  <td v-for="v in fields">
                    {{computeTotal(v, val[v])}}
                    <!-- <div style="width:100%;" v-if="v !== 'year' && computeBudget(v, key, val)" :style="computeBudget(v, key, val) < 0 ? 'color:red;' : 'color:green;'">
                      {{parseFloat(computeBudget(v, key, val)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </div> -->
                  </td>
                  <td>
                    {{parseFloat(computeAll(val)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    <!-- <div style="width:100%;" v-if="v !== 'year' && computeDivTotalBudget(val)" :style="computeDivTotalBudget(val) < 0 ? 'color:red;' : 'color:green;'">
                      {{parseFloat(computeDivTotalBudget(val)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </div> -->
                  </td>
                </tr>
                <tr>
                  <td>Budget</td>
                  <td v-for="v in fields" v-if="v !== 'year'">{{parseFloat(getBudget(v, key)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                  <td>{{parseFloat(computeDivBudget(key)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader style="background-color: #81b440;">Totals</CCardHeader>
          <CCardBody style="overflow-y:scroll;">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th v-for="val in fields">{{val.toUpperCase()}}</th>
                  <th>Totals</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="year in years">
                  <td v-for="v in fields">
                    {{computeAllTotal(v, year)}}
                    <!-- <div style="width:100%;" v-if="v !== 'year' && computeTotalBudget(v, year)" :style="computeTotalBudget(v, year) < 0 ? 'color:red;' : 'color:green;'">
                      {{parseFloat(computeTotalBudget(v, year)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </div> -->
                  </td>
                  <td>
                    {{parseFloat(computeComplete(year)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    <!-- <div style="width:100%;" v-if="computeTotalBudgetDiff(year)" :style="computeTotalBudgetDiff(year) < 0 ? 'color:red;' : 'color:green;'">
                      {{parseFloat(computeTotalBudgetDiff(year)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </div> -->
                  </td>
                </tr>
                <tr>
                  <td>Budget</td>
                  <td v-for="v in fields" v-if="v !== 'year'">{{parseFloat(computeTotalBudgets(v)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                  <td>
                    {{parseFloat(computeAllOfBudget()).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                  </td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      </div>

      <!-- <div style="width:100%;float:left;" v-if="!dashShow && reportData">
        <CButton size="sm" color="info" @click="dashShow = true, reportData = null" style="margin-bottom:5px;">Back</CButton>
        <sales-table :reportData="reportData"></sales-table>
      </div> -->
      <!-- </CCardBody>  
    </CCard> -->
    <!-- </CCol> -->
  </div>
</template>

<script>
import SalesTable from './sales_table'
var methods = {}

methods.getData = function () {
  
  axios.get(this.$apiAdress + '/api/getMonthlyNumbers?token=' + window.localStorage.getItem('api_token')).then(response => {
    console.log(response)
    var obj = {}
    var obj2 = {}
    response.data.months.forEach(function (val) {
      if (!obj[val.area]) {
        obj[val.area] = []
      }
      obj[val.area].push(val)
    })

    response.data.budgets.forEach(function (val) {
      if (!obj2[val.area]) {
        obj2[val.area] = []
      }
      obj2[val.area].push(val)
    })
    this.budgets = obj2
    console.log('budgets')
    console.log(this.budgets)
    this.data = obj
  }).catch(e => {
    
    
  })
}

methods.computeDivBudget = function (key) {
  var total = 0
  var i = 0
  var that = this
  this.budgets[key].forEach(function (val) {
    console.log(that.budgets[key])
    if (val.year === '2025') {
      for (var k in val) {
        if (val[k] && k !== 'created_at' && k !== 'updated_at' && k !== 'id' && k !== 'area' && k !== 'year') {
          total += parseFloat(val[k])
        }
      }
    }
    i++
  })
  return total
}

methods.computeBudget = function (v, key, value) {
  var total = ''
  var i = 0
  var that = this
  this.budgets[key].forEach(function (val) {
    
    if (val.year === value.year && parseFloat(value[v])) {
      total = (parseFloat(value[v]) || 0) - (parseFloat(that.budgets[key][i][v]) || 0)
    }
    i++
  })
  return total
}

methods.computeDivTotalBudget = function (val) {
  var total = 0
  var that = this
  this.fields.forEach(function (field) {
    if (field !== 'year') {
      if (val[field]) {
        // total += parseFloat(val[field])
        total += parseFloat(that.computeBudget(field, val.area, val))
      }
    }
  })
  return total
}

methods.computeAllOfBudget = function () {
  var total = 0
  for (var key in this.budgets) {
    total += parseFloat(this.computeDivBudget(key))
  }
  return total
}

methods.computeTotalBudget = function (v, year) {
  var total = 0
  // var i = 0
  var that = this
  // for (var key in this.budgets) {
  for (var key in this.data) {  
    this.data[key].forEach(function (value) {
      var i = 0
      that.budgets[key].forEach(function (val) {
        // console.log(val)
        // console.log(val[v])
        if (val.year === value.year && parseFloat(value[v]) && val.year === year) {
          total += parseFloat((parseFloat(value[v]) || 0) - (parseFloat(that.budgets[key][i][v]) || 0))
        }
        i++
      })
    })
  }
  return total
}

methods.computeTotalBudgetDiff = function (year) {
  var total = 0
  // var i = 0
  var that = this
  // for (var key in this.budgets) {
  this.fields.forEach(function (field) {
    if (field !== 'year') {
      total += parseFloat(that.computeTotalBudget(field, year))
    }
  })
  return total
}

methods.computeTotalBudgets = function (v) {
  var total = 0
  var i = 0
  var that = this
  for (var key in this.budgets) {
    this.budgets[key].forEach(function (val) {
      if (val.year === '2025') {
        total += parseFloat(parseFloat(val[v]) || 0)
      }
      i++
    })
  }
  return total
}

methods.getBudget = function (v, key) {
  var total = ''
  var i = 0
  var that = this
  this.budgets[key].forEach(function (val) {
    
    if (val.year === '2025') {
      total = (parseFloat(that.budgets[key.toUpperCase()][i][v]) || 0)
    }
    i++
  })
  return total
}

methods.computeDataComplete = function (value) {
  // this.years.forEach(function (year) {
    var total = 0
    var that = this
    value.forEach(function (val) {
      total += parseFloat(that.computeAll(val))
    })
    return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  // })
}

methods.computeCompleteYear = function () {
  var that = this
  var total = 0
  this.years.forEach(function (year) {
    total += parseFloat(that.computeComplete(year))
  })
  return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.computeDataTotal = function (v, value) {
  var total = 0
  var that = this
  var i = 0
  value.forEach(function (val) {
    for (var key in val) {
      if (key === v) {
        total += parseFloat(value[i][key]) || 0
      }
    }
    i++
  })
  return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.computeAllTotal = function (v, incomingYear) {
  var total = 0
  var that = this
  if (v !== 'year') {
    // this.years.forEach(function (year) {
      for (var key in that.data) {
        var i = 0
        that.data[key].forEach(function (value) {
          if (that.data[key][i].year === incomingYear && v !== 'year') {
            total += parseFloat(that.data[key][i][v]) || 0
          }
          i++
        })
      }
    // })
    return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return incomingYear
  }
}

methods.computeFinalTotal = function (v) {
  var that = this
  var total = 0
  this.years.forEach(function (year) {
    for (var key in that.data) {
      var i = 0
      that.data[key].forEach(function (value) {
        if (that.data[key][i].year === year) {
          total += parseFloat(that.data[key][i][v]) || 0
        }
        i++
      })
    }
  })
  return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.computeComplete = function (incomingYear) {
  var total = 0
  var that = this
  for (var key in that.data) {
    var i = 0
    that.data[key].forEach(function (value) {
      for (var k in value) {
        if (k !== 'year' && value.year === incomingYear && k !== 'created_at' && k !== 'updated_at' && k !== 'id') {
          total += parseFloat(that.data[key][i][k]) || 0
        }
      }
      i++
    })
  }
  return total
}

methods.showData = function (val) {
  
  this.reportData = val
  this.dashShow = false
}

methods.computeAll = function (val) {
  var total = 0
  this.fields.forEach(function (field) {
    if (field !== 'year') {
      if (val[field]) {
        total += parseFloat(val[field])
      }
    }
  })
  return total
}

methods.computeTotal = function (type, val) {
  if (type !== 'area' && type !== 'year') {
    if (val) {
      var total = val.toFixed(2)
      return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    } else {
      return val
    }
  } else {
    return val
  }
}

export default {
  name: 'MonthlyDashboard',
  data: () => {
    return {
      data: null,
      dashShow: true,
      reportData: null,
      budgets: null,
      fields: ['year', 'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
      years: ['2021', '2022', '2023', '2024', '2025']
    }
  },
  computed: {
  },
  components: {
    SalesTable
  },
  methods: methods,
  mounted: function(){
    this.getData();
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
